import api from '../services/api';

export interface iRebus {
  id_rebus: number;
  id_jogo: number;
  numeracao: string;
  solucao: string;
  imagem: string;
}

export const getRebus = async (id: number): Promise<iRebus> => {
  const response = await api.get(`/show_rebus/${id}`).catch((err) => {
    throw err;
  });

  return response.data[0];
};
